import { useEffect } from "react";
import { generateStaticPieNode } from "../../graph-util";
import { calculatePieChunks } from "../../utils";
import { CreateControlNodeOnlyFn, ItemWithClassification } from "../../@types";

interface Props {
  data: any[] | undefined;
  renderer: CreateControlNodeOnlyFn;
  counts: number;
}

const useRenderParentsRS = ({
  data: relationshipsData,
  renderer: createControlNodeFromData,
  counts: totalParents
}: Props) => {
  useEffect(() => {
    if (!relationshipsData || !totalParents) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "parentsNode",
          label: "Parents",
          points: calculatePieChunks(
            relationshipsData,
            (item: ItemWithClassification) => item.classification
          ),
          radius: 70,
          total: totalParents
        })
    });
  }, [createControlNodeFromData, relationshipsData, totalParents]);
};

export default useRenderParentsRS;
